

















































import { Component, Prop, Mixins } from 'vue-property-decorator'
import OzButton from 'library/v4/components/oz-button.vue'
import { IntlMixin } from 'vuemixins/intl_mixin'
@Component({ components: { OzButton } })
export default class SurfacePostAttachmentEmbedControl extends Mixins(IntlMixin) {
  @Prop() embedMetaHeight!: number
  @Prop() colorScheme!: 'light' | 'dark'
  @Prop() isDownloadable!: boolean
  @Prop() downloadUrl!: string
}
